export default __webpack_public_path__ + "static/media/banner3.131cd096.jpg";